export var ChunkHashAlgorithm = /*#__PURE__*/function (ChunkHashAlgorithm) {
  ChunkHashAlgorithm["Sha1"] = "sha1";
  ChunkHashAlgorithm["Sha256"] = "sha256";
  return ChunkHashAlgorithm;
}({});